/**
 * BZT Scroll Animations
 * Fade-in elements when they enter the viewport
 */

(function() {
  'use strict';

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    // Add animation classes to sections
    addAnimationClasses();

    // Set up Intersection Observer
    setupScrollObserver();
  }

  function addAnimationClasses() {
    // We'll use a more efficient way to target elements
    // In a real Shopify theme, it's better to add these classes in Liquid directly
    // but for this optimization, we'll minimize the impact

    const elementsToAnimate = [];

    // Hero content - animate left side
    const heroLeft = document.querySelector('.bzt-hero__left');
    if (heroLeft) {
      heroLeft.classList.add('bzt-animate-left');
      // Use requestAnimationFrame instead of setTimeout for better performance
      requestAnimationFrame(() => heroLeft.classList.add('bzt-visible'));
    }

    // Hero right side (video)
    const heroRight = document.querySelector('.bzt-hero__right');
    if (heroRight) {
      heroRight.classList.add('bzt-animate-right');
      requestAnimationFrame(() => heroRight.classList.add('bzt-visible'));
    }

    // Product list sections and other elements
    // Combine selectors to reduce querySelectorAll calls
    document.querySelectorAll('[class*="product-list"], .bzt-stat-item, .bzt-series-card, .bzt-timeline__item, .bzt-usps__item, .bzt-usps__heading, .bzt-h2, .bzt-section h2').forEach((el, index) => {
      if (el.classList.contains('bzt-stat-item')) {
        el.classList.add('bzt-animate', 'bzt-animate-scale');
      } else if (el.classList.contains('bzt-timeline__item')) {
        el.classList.add('bzt-animate');
        el.style.transitionDelay = `${index * 0.1}s`;
      } else if (!el.classList.contains('bzt-animate')) {
        el.classList.add('bzt-animate');
      }
    });
  }

  function setupScrollObserver() {
    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -50px 0px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('bzt-visible');
          // Important for performance: stop observing after animation is triggered
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    // Observe all animated elements
    document.querySelectorAll('.bzt-animate, .bzt-animate-left, .bzt-animate-right, .bzt-animate-scale').forEach(el => {
      observer.observe(el);
    });
  }

  function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top < (window.innerHeight || document.documentElement.clientHeight) &&
      rect.bottom >= 0
    );
  }

  // Re-initialize on Shopify section load (for theme editor)
  document.addEventListener('shopify:section:load', function() {
    addAnimationClasses();
    setupScrollObserver();
  });

})();

